// extracted by mini-css-extract-plugin
export var animationContainer = "_fo-0";
export var asteriskIcon = "_fo-8";
export var conversationLeftSection = "_fo-4";
export var conversationListItem = "_fo-3";
export var conversationMiddleSection = "_fo-5";
export var conversationRightSection = "_fo-6";
export var detailsContent = "_fo-1";
export var listContainer = "_fo-7";
export var modalContent = "_fo-2";